export { postCartPromo } from './promoApi';
